var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"left_pic"}),_c('div',{staticClass:"right_pic"}),_c('div',{staticClass:"bottom_pic"})])
}]

export { render, staticRenderFns }